import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { Transaction } from '../transaction/transaction';
import { RoleNameCacheRepository } from '../repositories/role-name-cache.repository';
import { RoleNameApiRepository } from '../repositories/role-name-api.repository';
import { RoleNameInterface } from '../data/role-name.interface';

@Injectable()
export class RoleNameProvider {
    constructor(private roleNameApiRepository: RoleNameApiRepository, private roleNameCacheRepository: RoleNameCacheRepository) {}

    find(): Observable<Transaction<RoleNameInterface[]>> {
        return concat(
            this.roleNameCacheRepository.load(),
            this.roleNameApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.roleNameCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
